import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NameSectionForm from '../../../../../ReusableFormSections/NameSection/NameSectionForm'

import { updateLineItem, clearUpdateLineItem } from '../../../../../../modules/actions/lineItems'
import {
  lineItemUpdateErrorSelector,
  lineItemUpdateIsLoadingSelector,
  lineItemWasUpdatedSelector
} from '../../../../../../modules/selectors/lineItems'
import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { DV_360_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

function NameSection({ editItemData: item, title, ...formProps }) {
  const dispatch = useDispatch()

  const itemWasUpdated = useSelector(lineItemWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const handleSubmit = useCallback(
    values => {
      const updateLineItemData = {
        account: selectedAdAccountId,
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        },
        ...values
      }

      dispatch(updateLineItem(updateLineItemData, item.id, DV_360_PLATFORM))
    },
    [dispatch, item.id, selectedAdAccountId, title]
  )

  const handleClearUpdateItem = useCallback(() => {
    dispatch(clearUpdateLineItem())
  }, [dispatch])

  return (
    <NameSectionForm
      placeholder="Line Item Name"
      editItem={item}
      handleSubmit={handleSubmit}
      clearEditItem={handleClearUpdateItem}
      successSubmit={itemWasUpdated}
      isLoadingSelector={lineItemUpdateIsLoadingSelector}
      errorSelector={lineItemUpdateErrorSelector}
      {...formProps}
    />
  )
}

export default NameSection
